import { Component, OnInit, Input } from '@angular/core';
import * as JsBarCode from 'jsbarcode';
import { MediaObserver } from '@angular/flex-layout';


@Component({
  selector: 'app-barcode-client',
  templateUrl: './barcode-client.component.html',
  styleUrls: ['./barcode-client.component.css']
})
export class BarcodeClientComponent implements OnInit {

  @Input() clientAccount: any;

  constructor(
    private media: MediaObserver
  ) { }

  ngOnInit() {
    this.initBarCode();
  }

  initBarCode() {
    setTimeout(() => {
      JsBarCode("#barcode", "ful_" + this.clientAccount.id + "_" + this.clientAccount.uid.substring(0, 7), {
        format: "code128",
        background: "#fafafa",
        textMargin: 0,
        displayValue: false,
      });
    });
  }


}
